import { HeaderBarCenter } from "slot-definitions"
import { ShareLinkSearchBox } from "./share-link-search-box"

HeaderBarCenter.plug(<ShareLinkSearchBox priority={100} />)
